<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="common_title">
        合约资金流水
        <TopPartner @refreshTopPartner="handleSearch"></TopPartner>
      </div>

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="顶级合伙人UID"
                clearable
                v-model="topUserId"
                class="userUid_ipt"
                size="mini"
              />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                class="userUid_ipt"
                size="mini"
              />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="仓位ID"
                size="mini"
                clearable
                v-model="positionId"
              />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                v-model="channelUserId"
                class="userUid_ipt"
                size="mini"
              />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="订单ID"
                clearable
                v-model="bizId"
                class="userUid_ipt"
                size="mini"
              />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select size="mini" v-model="billType" placeholder="请选择">
                <el-option label="全部类型" value="" />
                <el-option
                  v-for="item in billTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select size="mini" v-model="coin" placeholder="请选择">
                <el-option label="全部币种" value="" />
                <el-option
                  v-for="item in coinList"
                  :key="item.id || item.coin || item"
                  :label="(item.coin || item || '').toUpperCase()"
                  :value="item.coin || item"
                />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-date-picker
                v-model="value1"
                size="mini"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              />
            </div>
          </div>
          <div class="item">
            <div class="item-sle">
              <div class="tit">特殊账号</div>
              <el-select size="mini" v-model="type" placeholder="特殊账号">
                <el-option
                  v-for="item in [
                    { id: 1, value: '隐藏' },
                    { id: 2, value: '显示' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                />
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="item-sle">
              <div class="tit">账户类型</div>
              <el-select size="mini" v-model="balanceType" placeholder="账户类型">
                <el-option label="全部类型" value="" />
                <el-option label="合约" :value="1" />
                <el-option label="跟单" :value="8" />
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item">
            <a @click="getExcel" target="_blank">导出Excel</a>
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList" />
    </el-card>
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { PAGINATION, BILL_TYPE_OPTIONS } from "./constants";
import userUid from "@/assets/input/userUid.png";
import invite from "@/assets/input/invite.png";
import channel from "@/assets/input/channel.png";
import TopPartner from "../topPartner";

export default {
  name: "contractBill",
  components: {
    UserList,
    TopPartner,
  },
  data() {
    return {
      invite,
      channel,
      userUid,
      type: 1,
      topUserId: "",
      userId: "",
      channelUserId: "",
      positionId: "",
      bizId: "",
      billType: "",
      coin: "",
      balanceType: "",
      value1: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      billTypeOptions: BILL_TYPE_OPTIONS,
    };
  },
  computed: {
    ...mapState("contractBill", ["pagination", "coinList"]),
    ...mapState("topPartner", ["topPartner"]),
  },
  methods: {
    ...mapActions("contractBill", ["list", "exportExcel", "getCoinList"]),
    ...mapMutations("contractBill", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        topUserId: this.topUserId || this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId: this.positionId,
        bizId: this.bizId,
        billType: this.billType,
        coin: this.coin,
        type: this.type,
        balanceType: this.balanceType,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...this.pagination,
        ...data,
      });
    },
    getExcel() {
      this.exportExcel({
        topUserId: this.topUserId || this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId: this.positionId,
        bizId: this.bizId,
        billType: this.billType,
        coin: this.coin,
        type: this.type,
        balanceType: this.balanceType,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...this.pagination,
      }).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.download = "合约资金流水";
        document.body.appendChild(link);
        link.click();
      });
    },
    handleSearch() {
      this.list({
        topUserId: this.topUserId || this.topPartner,
        channelUserId: this.channelUserId,
        userId: this.userId,
        positionId: this.positionId,
        bizId: this.bizId,
        billType: this.billType,
        coin: this.coin,
        type: this.type,
        balanceType: this.balanceType,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        ...PAGINATION,
      });
    },
  },
  created() {
    this.getCoinList();
    this.handleSearch();
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
